export function toProgressCount(count: number) {
  return count > 100 ? 100: count;
}